import etsy_logo from '../images/etsy_logo.png';
import amazon_logo from '../images/amazon_logo.png';
import shopify_logo from '../images/shopify_logo.png';
import jane_logo from '../images/jane_logo.png';
import ucg_logo from '../images/ucg_logo.png';
import po_logo from '../images/po_logo.png'
import { Box } from '@mui/material';

function storeImage(kind) {
    var img = null;
    if (kind === "Shopify" || kind === "") {
        img = shopify_logo;
    } else if (kind === "Etsy") {
        img = etsy_logo;
    } else if (kind === "JANE") {
        img = jane_logo;
    } else if (kind === "ucg") {
        img = ucg_logo;
    } else if (kind === "Amazon") {
        img = amazon_logo;
    } else if (kind === "PO") {
        img = po_logo;
    } else if (kind === "ShipStation") {
        return ""
    }
    if (img) {
        return <Box component="img" src={img} sx={{width: 24, height: 24, marginRight: 1}} />
    }
    return kind;
}

function storeName(name) {
    return name.replace("leftcoast", "LC").replace("weddings", "W").replace("original", "O").replace("AMZ Left Coast Original", "LCO").replace("Left Coast Cabinets", "LCC");
}

export {storeName, storeImage}